import React from 'react'

const TicketSvg = ({ width, height, focus }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 28.4 22.72'
    >
      <path
        id='ticket-svgrepo-com'
        d='M19.051,25.3l.008-2.844a1.424,1.424,0,0,1,2.847,0v2.807c0,.684,0,1.026.219,1.235s.555.2,1.226.167c2.645-.112,4.271-.47,5.416-1.613s1.506-2.772,1.617-5.421a2.044,2.044,0,0,0-.065-.963,4.384,4.384,0,0,0-1.273-.832,2.837,2.837,0,0,1,0-4.959,4.385,4.385,0,0,0,1.273-.832,2.045,2.045,0,0,0,.065-.964c-.111-2.65-.469-4.276-1.617-5.421-1.246-1.243-3.06-1.557-6.138-1.637a.706.706,0,0,0-.723.706V8.26a1.424,1.424,0,0,1-2.847,0l-.01-3.552A.711.711,0,0,0,18.337,4H13.353C7.984,4,5.3,4,3.632,5.664,2.484,6.809,2.126,8.435,2.015,11.085a2.045,2.045,0,0,0,.065.964,4.385,4.385,0,0,0,1.273.832,2.837,2.837,0,0,1,0,4.959,4.384,4.384,0,0,0-1.273.832,2.045,2.045,0,0,0-.065.963c.111,2.65.469,4.276,1.617,5.421C5.3,26.72,7.984,26.72,13.353,26.72h4.275c.669,0,1,0,1.212-.207S19.049,25.972,19.051,25.3Zm2.855-8.524V13.94a1.424,1.424,0,0,0-2.847,0v2.84a1.424,1.424,0,0,0,2.847,0Z'
        transform='translate(-2 -4)'
        fill={focus ? '#205c42' : '#fff'}
        fillRule='evenodd'
      />
    </svg>
  )
}

export default TicketSvg
